;(function () {
  angular
    .module('contrast.org-stats')
    .controller(
      'OrgStatsLicensesCtrl',
      function (
        $scope,
        OrgStatsService,
        LoadFilterRouteService,
        CHART_EVENTS,
        CHART_ID
      ) {
        'ngInject'

        var vm = this

        angular.extend(vm, {
          licenses: {
            data: {},
            donutConfig: {
              overall: {},
              assess: {},
              protect: {}
            },
            assessBreakdown: {},
            protectBreakdown: {},
            trendConfig: {
              data: {},
              interval: {}
            },
            timelines: {
              assess: {},
              protect: {}
            }
          },
          protectUsage: {
            trendConfig: {
              data: {},
              interval: {}
            },
            metrics: {
              agentUsage: {
                avg: undefined,
                peak: undefined,
                total: undefined
              },
              usageHours: {
                avg: undefined,
                peak: undefined,
                total: undefined
              }
            },
            months: {
              items: [],
              selectedItem: {},
              itemToString: function (item) {
                return item.value
              },
              itemToKey: function (item) {
                return item.startDate + ''
              },
              onItemChange: function (item) {
                vm.protectUsage.months.selectedItem = item

                _getProtectUsageHistory(
                  vm.protectUsage.trendConfig.data.totalProtectLicenses
                )

                return item
              }
            }
          },
          statsLoading: true,
          protectUsageStatsPromise: false,
          showProtectUsage: false,
          isUsageHours: false
        })

        angular.extend(vm, {
          goToUnlicensedApps: LoadFilterRouteService.goToUnlicensedApps,
          hasUnlicensedApps: hasUnlicensedApps,
          hasUnlicensedServers: hasUnlicensedServers,
          hasAssessLicenses: hasAssessLicenses,
          hasProtectLicenses: hasProtectLicenses,
          breakdownsLoading: true,
          backToLicenseActivity: backToLicenseActivity,
          viewProtectUsage: viewProtectUsage
        })

        function init() {
          _getLicenseStats()
          _getLicenseBreakdowns()

          $scope.$on(CHART_EVENTS.LOAD_PROTECT_USAGE, function (event, data) {
            vm.showProtectUsage = true

            vm.isUsageHours =
              CHART_ID.PROTECT_USAGE_HOURS_CHART === data.chartId

            if (data.retrieveData) {
              vm.protectUsageStatsPromise = false

              _getProtectUsage(data.totalProtectLicenses)
            } else {
              vm.protectUsageStatsPromise = true
            }
          })
        }

        function viewProtectUsage() {
          $scope.$broadcast(
            CHART_EVENTS.DRILLDOWN_LICENSE_ACTIVITY_TO_AGENT_USAGE,
            { totalProtectLicenses: vm.licenses.data.totalProtection }
          )
        }

        function hasUnlicensedApps() {
          return vm.licenses.data.unlicensedApps !== 0
        }

        function hasUnlicensedServers() {
          return vm.licenses.data.unlicensedServers !== 0
        }

        function hasAssessLicenses() {
          return vm.licenses.data.totalAssessment !== 0
        }

        function hasProtectLicenses() {
          return vm.licenses.data.totalProtection !== 0
        }

        function backToLicenseActivity() {
          vm.showProtectUsage = false
          vm.showAgentUsage = false
          vm.showUsageHours = false

          $scope.$broadcast(CHART_EVENTS.RENDER_LICENSES_ACTIVITY)
        }

        function _getLicenseStats() {
          vm.statsLoading = true
          vm.statsLoadingPromise = OrgStatsService.getLicenseStats()
            .then(function (stats) {
              vm.licenses.data = stats.data
              vm.licenses.donutConfig = stats.donutConfig
              vm.licenses.trendConfig = stats.trendConfig
            })
            .finally(function () {
              vm.statsLoading = false
            })
        }

        function _getLicenseBreakdowns() {
          vm.breakdownsLoading = true
          OrgStatsService.getLicenseBreakdowns()
            .then(function (breakdowns) {
              if (angular.isDefined(breakdowns.assessBreakdown)) {
                vm.licenses.assessBreakdown = breakdowns.assessBreakdown.summary
                vm.licenses.timelines.assess =
                  breakdowns.assessBreakdown.timeline
              }
              if (angular.isDefined(breakdowns.protectBreakdown)) {
                vm.licenses.protectBreakdown =
                  breakdowns.protectBreakdown.summary
                vm.licenses.timelines.protect =
                  breakdowns.protectBreakdown.timeline
              }
            })
            .finally(function () {
              vm.breakdownsLoading = false
            })
        }

        function _getProtectUsage(totalProtectLicenses) {
          vm.protectUsageLoadingPromise = _getProtectUsageTimeFrame().then(
            function () {
              _getProtectUsageHistory(totalProtectLicenses)
            }
          )
        }

        function _getProtectUsageTimeFrame() {
          return OrgStatsService.getProtectUsageHistoryOldestDate().then(
            function (data) {
              vm.protectUsage.months.items =
                OrgStatsService.buildProtectUsageDropdownItems(
                  data.oldest_usage_date
                )
              vm.protectUsage.months.selectedItem =
                vm.protectUsage.months.items[0]
            }
          )
        }

        function _getProtectUsageHistory(totalProtectLicenses) {
          vm.protectUsageStatsPromise = false
          vm.protectUsageLoadingPromise =
            OrgStatsService.getProtectUsageHistory(
              vm.protectUsage.months.selectedItem.startDate,
              vm.protectUsage.months.selectedItem.endDate
            )
              .then(function (data) {
                //prepare data for Protect Usage Panel
                vm.protectUsage.metrics =
                  OrgStatsService.buildProtectUsageMetrics(data.usage_metrics)

                //prepare data for Protect Usage Chart
                vm.protectUsage.trendConfig =
                  OrgStatsService.buildProtectUsageTrend(
                    data.usage_history,
                    totalProtectLicenses
                  )
              })
              .finally(function () {
                vm.protectUsageStatsPromise = true
              })
        }

        init()
      }
    )
})()
